import httpRequest from "@/auth/http-client";
import { buildPaginationQuery } from "@/helpers/request-helpers";
import ICustomer, { ICustomerInput } from "@/interfaces/customer.interfaces";
import { IFilter } from "@/types/filter.types";
import { PaginatedResponse, RequestPagination } from "@/types/requests.types";

class CustomerService {
  private baseUrl = "api/v1/customer";

  async getAllCustomers(pagination: RequestPagination): Promise<PaginatedResponse<ICustomer>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const customers = await httpRequest.get(`${this.baseUrl}?${paginationQuery}`);
    return customers;
  }

  async filterCustomers(
    filter: IFilter<ICustomer>[],
    pagination: RequestPagination
  ): Promise<PaginatedResponse<ICustomer>> {
    const paginationQuery = buildPaginationQuery(pagination);

    const response = await httpRequest.post(`${this.baseUrl}/filter?${paginationQuery}`, {
      filter,
    });

    return response;
  }

  async getCustomerById(customerId: number): Promise<ICustomer> {
    const customer = await httpRequest.get(`${this.baseUrl}/${customerId}`);
    return customer;
  }

  async createCustomer(customerData: ICustomerInput): Promise<void> {
    return await httpRequest.post(this.baseUrl, customerData);
  }

  async update(formData: FormData, customerId: number, accessToken: string): Promise<ICustomer> {
    const teste = await httpRequest.put(`${this.baseUrl}/${customerId}`, formData, {
      headers: {
        "Content-Type": "multipart/form-data",
        Authorization: `Bearer ${accessToken}`,
        Accept: "application/json",
        customerId: customerId,
      },
    });

    return teste;
  }

  async deleteCustomer(customerId: number): Promise<void> {
    await httpRequest.delete(`${this.baseUrl}/${customerId}`);
  }
}

const customerService = new CustomerService();
export default customerService;
